import React from 'react';
import { Typography } from 'antd';
import { signupPalette } from './signupTheme';

const { Text } = Typography;

type Props = {
    icon: React.ReactNode;
    label: string;
    description?: string;
    selected: boolean;
    onSelect: () => void;
};

/**
 * Grande carte cliquable — un choix par carte, assez large pour le tactile.
 * Utilisée aux étapes « papa ou maman » et « compte conjoint ».
 */
const ChoiceCard: React.FC<Props> = ({ icon, label, description, selected, onSelect }) => (
    <div
        role="radio"
        aria-checked={selected}
        tabIndex={0}
        onClick={onSelect}
        onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect();
            }
        }}
        style={{
            flex: '1 1 200px',
            minHeight: 132,
            cursor: 'pointer',
            borderRadius: 16,
            padding: '20px 16px',
            textAlign: 'center',
            transition: 'all 0.2s ease',
            background: selected ? `${signupPalette.primary}0f` : signupPalette.surface,
            border: `2px solid ${selected ? signupPalette.primary : signupPalette.border}`,
            boxShadow: selected ? `0 0 0 4px ${signupPalette.primary}1a` : 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
        }}
    >
        <span style={{ fontSize: 34, color: selected ? signupPalette.primary : signupPalette.textSecondary, lineHeight: 1 }}>
            {icon}
        </span>
        <Text
            style={{
                fontSize: 17,
                fontWeight: 600,
                color: selected ? signupPalette.primary : signupPalette.textPrimary,
            }}
        >
            {label}
        </Text>
        {description && (
            <Text style={{ fontSize: 13, color: signupPalette.textSecondary, lineHeight: 1.4 }}>{description}</Text>
        )}
    </div>
);

export default ChoiceCard;
